import type { PermissionScopeResources } from "~types/permissionScope.ts";
import type { UserPermission } from "~types/userPermission";
import { PermissionScopeTypes } from "../enums/permissionScopeTypes";
import type { UserPermissionTransformed } from "../types";

const transformUserPermission = (
  permission: UserPermission,
  isGroupPermission: boolean,
  resources: PermissionScopeResources | undefined,
): UserPermissionTransformed => {
  const getScopeObjectName = (id: string) => {
    switch (permission.scope) {
      case PermissionScopeTypes.League:
        return resources?.leagues?.[id]?.nameLocal ?? id;
      case PermissionScopeTypes.Competition:
        return resources?.competitions?.[id]?.nameLocal ?? id;
      case PermissionScopeTypes.Season:
        return resources?.seasons?.[id]?.nameLocal ?? id;
      case PermissionScopeTypes.Entity:
        return resources?.entities?.[id]?.nameFullLocal ?? id;
      case PermissionScopeTypes.EntityGroup:
        return resources?.entityGroups?.[id]?.nameFullLocal ?? id;
      default:
        return id;
    }
  };

  const scopeValues =
    permission.scopeIds?.map((id) => ({
      value: id,
      label: getScopeObjectName(id),
    })) || null;

  const getScopeTypeValues = (scopeType: PermissionScopeTypes) => (scopeType === permission.scope ? scopeValues : null);

  return {
    ...permission,
    scopeValues,
    isGroupPermission,
    leagues: getScopeTypeValues(PermissionScopeTypes.League),
    competitions: getScopeTypeValues(PermissionScopeTypes.Competition),
    seasons: getScopeTypeValues(PermissionScopeTypes.Season),
    entities: getScopeTypeValues(PermissionScopeTypes.Entity),
    entityGroups: getScopeTypeValues(PermissionScopeTypes.EntityGroup),
  };
};

export default transformUserPermission;
